var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found flex"},[_c('svg-vue',{staticClass:"not-found-image",attrs:{"icon":"404"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }